import React from 'react';
function SterStaticLabel(props) {

    return (

        <React.Fragment>
            <div className={`e-label ${!!props.custom && !!props.custom.required && props.custom.required ? "text-danger" : ''} ${!!props.custom && !!props.custom.class ? props.custom.class : ''}`} title={!!props.custom && !!props.custom.caption ? props.custom.caption : "NA"}>
                {!!props.custom && !!props.custom.caption ? props.custom.caption : "NA"}
                {!!props.custom && !!props.custom.required && props.custom.required ? <span className="c-error">*</span> : null}
            </div>
        </React.Fragment >
    );

};
export default SterStaticLabel;






